module.exports = __webpack_public_path__ + "static/media/willo_invite-comma.fec214a4.txt";